/**
 * icon-xiazai
 * params 查询参数 必须属性
 * type 每个页面的导出类型
 */
import {message, notification} from "antd";
import {AuthButton} from "@/globalComponents"
import React, { forwardRef, useRef } from 'react'
import { WWMethods } from "@/tools";
import "./index.scss"
import AddEmails from "./AddEmails";
import {RouteUtil} from "@/routers";
const {urlJson,keyTitleJson} = RouteUtil;
import {WWUtils} from "@/tools";
import { useNavigate } from 'react-router-dom';
function ExportFileInstruct (props,ref) {
    const addEmailRef = useRef(null);
    const navigate = useNavigate();
    //导出设置
    const setExpType = (expType) =>{
        if(expType === "local"){
            createTask(expType)
        }else{
            addEmailRef.current.setVisible();
        }

    }
    //创建导出任务
    const createTask =(expType,emails)=>{
        let params = {};
        params.type = props.type;//导出类型
        params.fileType = 1;//1:excel,2:pdf
        params.param = props.params;//页面参数
        //邮箱导出获取邮箱数据
        if((expType === "email") && emails ){
            let temp_emails = emails.filter((item)=>item !== "");
            params.emails = temp_emails;
        }
        WWMethods.downloadVinList(params,(data)=>{
            if(data.code === 0){
                createNotice(expType);
                if(expType === "email"){
                    addEmailRef.current.hideModal();
                }
            }else {
                message.error(data.message)
            }
        })
    }
    //进入导出列表页面
    const gotoExpList = ()=>{
        let url = urlJson["5-1"];
        let params = {type:props.type}
        if(props.closeModal && (typeof props.closeModal === "function") ){
            props.closeModal()
        }
        WWUtils.addNavigationTab("5-1",keyTitleJson["5-1"],params);
        navigate(url,{state:params});
    }
    const createNotice =(expType)=>{
        let popTips =<a onClick={()=>{gotoExpList()}}>{Strings.downloadEmailTips || "导出任务已执行，点击此处或稍后自行前往导出任务进行下载保存，任务执行完毕将会向您邮箱推送数据。"}</a> ;
        if(expType === "local"){
            popTips = <a onClick={()=>{gotoExpList()}}>{Strings.downloadLocalTips || "导出任务已执行，点击此处或稍后自行前往导出任务进行下载保存。"}</a>
        }
        let exportTitle = Strings.downloading || "导出中"
        notification.destroy();
        notification.open({
            message:exportTitle,
            description:popTips,
            getContainer:()=>document.getElementById("exportAnchor_"+props.type),
            icon:<i className="icon green iconfont icon-daochuzhong"></i>,
            duration: 10,
            top:150
        })
    }
    return (<div id={"exportAnchor_"+props.type} className={"exportwrapper"} style={{position:"relative",display:"flex"}}>
        <AuthButton authKey={true} widthType={1} type="reset" onClick={()=>{setExpType("local")}}>{Strings.downloadlocal || "导出至本地"}</AuthButton>
        <AuthButton authKey={true} widthType={1} className="mgl10" type="reset" onClick={()=>{setExpType("email")}}>{Strings.downloademail|| "导出至邮箱"}</AuthButton>
        <AddEmails ref={addEmailRef} setEmailsData={(emails)=>createTask("email",emails)}></AddEmails>
    </div>)
}
export default forwardRef(ExportFileInstruct)

